import adminApiClient from './apiClient.js';

export const checkinsApi = {
  listPorSpace: async (params = {}) => {
    const { data } = await adminApiClient.get('/checkins/por-space', { params });
    return data;
  },
};

export default checkinsApi;
